# Sommeil & repos : siestes, nuit et espaces calmes

Le repos soutient la récupération, l’humeur et l’immunité. Les animaux dorment beaucoup, mais la qualité du repos dépend de la routine, du confort et d’un environnement apaisant.

<ArticleImage
  src="/images/guide/sleep-rabbit.jpg"
  alt="Horloge sur une table de chevet"
  caption="Une routine stable aide l’animal à s’endormir plus facilement."
/>

---

<Section emoji="🌙" title="Rythmes de sommeil sains">

<Tip label="Durées typiques" text="Les chiens adultes dorment souvent 12–14 h ; les chats 12–16 h. Chiots, chatons et seniors dorment davantage." />
<Tip label="Siestes" text="Les siestes sont normales — observez surtout l’énergie et l’appétit global." />
<Tip label="Changements" text="Si le sommeil change soudainement, notez aussi les autres symptômes." />

</Section>

<ArticleImage
  src="/images/guide/sleep-cat-cozy.jpg"
  alt="Lumière calme"
  caption="Un espace cosy et tranquille favorise un repos profond."
/>

<Section emoji="🏡" title="Créer une zone de repos">

<Tip label="Confort" text="Proposez un couchage doux et une température adaptée au type de pelage." />
<Tip label="Peu de bruit" text="Éloignez la zone de repos des TV, portes ou couloirs fréquentés." />
<Tip label="Espace sûr" text="Les cages ou paniers fermés rassurent certains animaux." />

</Section>

<Section emoji="📖" title="Routine du coucher">

<Tip label="Même horaire" text="Gardez la dernière sortie, le dernier repas et l’extinction des lumières constants." />
<Tip label="Retour au calme" text="Un brossage doux ou un jeu tranquille aide à relâcher l’énergie." />
<Tip label="Lumière" text="Tamisez les lumières le soir pour signaler l’heure du repos." />

</Section>

<Section emoji="🩺" title="Quand consulter">

<Tip label="Nuits agitées" text="Va‑et‑vient, halètements ou réveils fréquents peuvent signaler un inconfort." />
<Tip label="Somnolence excessive" text="Une léthargie soudaine mérite un avis vétérinaire." />
<Tip label="Signes de douleur" text="Raideur, boiterie ou gémissements peuvent perturber le sommeil." />

</Section>

<Disclaimer title="⚠️ Petit rappel">
Ce guide est éducatif et ne remplace pas un avis vétérinaire. Si les changements de sommeil persistent, contactez votre vétérinaire.
</Disclaimer>
